import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PageDto } from './../shared/page.dto';
import { ChannelDto } from './../channel/channel.dto';
import { PageQueriesModel } from './../shared';

@Injectable()
export class ChannelsRestService {
  constructor(private http: HttpClient) {}

  list(queries: PageQueriesModel, clientId?: string) {
    const url = this.apiListUrl(clientId);
    const params = {
      params: queries.getParams()
    };
    return this.http.get<PageDto<ChannelDto>>(url, params).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new ChannelDto(i));
        return page;
      })
    );
  }

  get(id: string): Observable<ChannelDto> {
    const url = this.apiListUrl() + '/' + id;
    return this.http
      .get<ChannelDto>(url)
      .pipe(map(data => new ChannelDto(data)));
  }

  post(d: ChannelDto, clientId: string) {
    const url = this.getListUrlByClient(clientId);
    return this.http
      .post<ChannelDto>(url, d)
      .pipe(map(data => new ChannelDto(data)));
  }

  patch(d: ChannelDto, clientId: string, channelId: string) {
    const url = this.getListUrlByClient(clientId) + '/' + channelId;
    return this.http
      .patch<ChannelDto>(url, d)
      .pipe(map(data => new ChannelDto(data)));
  }

  put(d: ChannelDto, clientId: string, channelId: string) {
    const url = this.getListUrlByClient(clientId) + '/' + channelId;
    return this.http
      .put<ChannelDto>(url, d)
      .pipe(map(data => new ChannelDto(data)));
  }

  delete(channelId: string, clientId: string) {
    const url = this.getListUrlByClient(clientId) + '/' + channelId;
    return this.http.delete(url);
  }

  private apiListUrl(id?: string) {
    return id ? this.getListUrlByClient(id) : 'api/channelManagement/channels';
  }

  private getListUrlByClient(id: string) {
    return `api/channelManagement/clients/${id}/channels`;
  }
}
